<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.pt_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="pt_task">
            <label class="weui-form-preview__label">{{
              customLabel.pt_task || "任务名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pt_task
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pt_emname">
            <label class="weui-form-preview__label">{{
              customLabel.pt_emname || "任务处理人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pt_emname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pt_planenddate">
            <label class="weui-form-preview__label">{{
              customLabel.pt_planenddate || "要求完成日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.pt_planenddate
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pt_taskstatus">
            <label class="weui-form-preview__label">{{
              customLabel.pt_taskstatus || "任务状态"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pt_taskstatus
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pt_code">
            <label class="weui-form-preview__label">{{
              customLabel.pt_code || "问题反馈单号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pt_code
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pt_reason">
            <label class="weui-form-preview__label">{{
              customLabel.pt_reason || "问题原因"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pt_reason
            }}</span>
          </div>

          <div class="weui-form-preview__item" slot="pt_result">
            <label class="weui-form-preview__label">{{
              customLabel.pt_result || "处理方法"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pt_result
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pt_actbegindate">
            <label class="weui-form-preview__label">{{
              customLabel.pt_actbegindate || "实际开始时间"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.pt_actbegindate
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pt_actenddate">
            <label class="weui-form-preview__label">{{
              customLabel.pt_actenddate || "实际完成时间"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.pt_actenddate
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pt_actworkhour">
            <label class="weui-form-preview__label">{{
              customLabel.pt_actworkhour || "实际工时"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pt_actworkhour
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pt_pjcode">
            <label class="weui-form-preview__label">{{
              customLabel.pt_pjcode || "项目单号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pt_pjcode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pj_dename">
            <label class="weui-form-preview__label">{{
              customLabel.pj_dename || "项目名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pj_dename
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pj_emname">
            <label class="weui-form-preview__label">{{
              customLabel.pj_emname || "项目负责人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pj_emname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pj_emtel">
            <label class="weui-form-preview__label">{{
              customLabel.pj_emtel || "联系电话"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pj_emtel
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pt_rpname">
            <label class="weui-form-preview__label">{{
              customLabel.pt_rpname || "项目阶段"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pt_rpname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pp_emname">
            <label class="weui-form-preview__label">{{
              customLabel.pp_emname || "阶段负责人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pp_emname
            }}</span>
          </div>
        </custom-layout>
      </div>

      <file-list v-model="form.main.pt_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/plm/problem_task_edit?id=' + form.main.id"
        v-if="editable && form.main.pt_taskstatus != '完成'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable && form.main.pt_taskstatus != '完成'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
  },
  data() {
    return {
      baseUrl: "/api/plm/problemtask",
      codeField: "pt_code",
      statusField: "pt_statuscode",
      caller: "PlmProblemTask",
      xtype: "plm-problemtask-formpanel",
    };
  },
};
</script>
